import { useStateList, useCreateShippingZone } from "./hooks";
import React from "react";
import {
  Intent,
  Button,
  InputGroup,
  Classes,
  Dialog,
  FormGroup,
  Callout
} from "@blueprintjs/core";
import styles from "../ShippingSettings.module.scss";
import FormInfo from "../../../../atoms/FormInfo/FormInfo";
import { SelectList } from "../../../../molecules/SelectList";

export function CreateShippingZoneButton({
  shippingProfileId,
  selectedStates
}) {
  const {
    isModalOpen,
    setIsModalOpen,
    onCloseDialog,
    stateIds,
    setStateIds,
    searchText,
    setSearchText,
    zoneName,
    setZoneName,
    onCreateShippingZone,
    isSaving,
    isSubmitDisabled,
    onToggleRestOfWorld,
    isRestOfWorld,
    error
  } = useCreateShippingZone(shippingProfileId);

  const { statesList, loading } = useStateList(
    searchText,
    isModalOpen,
    selectedStates
  );

  return (
    <>
      <Dialog
        icon="cube"
        onClose={onCloseDialog}
        title="Create Zone"
        isOpen={isModalOpen}
        className={styles.simpleDialog}
        canOutsideClickClose={!isSaving}
        canEscapeKeyClose={!isSaving}
      >
        <div className={Classes.DIALOG_BODY}>
          {error && (
            <div className={styles.errorCallout}>
              <Callout
                icon="error"
                intent={Intent.DANGER}
                // title="We couldn't save your shipping zone."
              >
                {error}
              </Callout>
            </div>
          )}
          <FormInfo>
            Use shipping zones to choose the regions that you ship to, and
            define your shipping rates for each zone.
          </FormInfo>
          <FormGroup
            label="Zone Name"
            labelFor="zoneName"
            helperText="Customers won't see this."
          >
            <InputGroup
              id="zoneName"
              value={zoneName}
              onChange={setZoneName}
              placeholder="e.g. United States"
            />
          </FormGroup>
          <FormGroup labelFor="zoneSearch">
            <InputGroup
              leftIcon="search"
              type="search"
              id="zoneSearch"
              value={searchText}
              onChange={setSearchText}
              placeholder="Search countries and regions"
            />
          </FormGroup>
          <SelectList
            data={statesList}
            value={stateIds}
            onChange={setStateIds}
            loading={loading}
            emptyListMessage="No regions or countries available"
            secondaryValue={isRestOfWorld}
            secondaryLabel="Rest of World"
            secondaryOnChange={onToggleRestOfWorld}
          />
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              text="Cancel"
              type="button"
              minimal="true"
              disabled={isSaving}
              onClick={onCloseDialog}
              intent={Intent.NONE}
            />
            <Button
              text="Save"
              disabled={isSubmitDisabled}
              loading={isSaving}
              onClick={onCreateShippingZone}
              intent={Intent.PRIMARY}
            />
          </div>
        </div>
      </Dialog>
      <Button
        text="Create Shipping Zone"
        intent={Intent.PRIMARY}
        minimal={true}
        onClick={() => setIsModalOpen(true)}
      />
    </>
  );
}
